import { bigIntToLong } from '#common/util';
import { KeyRangeLockingRequestMsg, ServiceBaseProto, UnlockMsg, UnlockRange } from '#websocket/client/proto';
import { LockResponse } from './response';
import { KEY_RANGE_LOCKING_REQUEST_TYPE } from './types';
export class UnlockRangesRequest {
    unlockRanges;
    destination;
    constructor(unlockRanges, destination) {
        this.unlockRanges = unlockRanges;
        this.destination = destination;
    }
    createMessage(requestId, version) {
        const unlockRanges = [];
        for (const unlockRange of this.unlockRanges) {
            unlockRanges.push(UnlockRange.create({
                lockOwner: unlockRange.lockOwner,
                startKey: unlockRange.range.start,
                endKey: unlockRange.range.limit,
            }));
        }
        const unlockMessage = UnlockMsg.create({
            unlockRange: unlockRanges,
        });
        const unlockRequest = KeyRangeLockingRequestMsg.create({
            type: KeyRangeLockingRequestMsg.RequestType.UNLOCK,
            unlock: unlockMessage,
        });
        return ServiceBaseProto.RequestMsg.create({
            id: bigIntToLong(requestId),
            versionMajor: version.major,
            versionMinor: version.minor,
            versionBuild: version.build,
            [KEY_RANGE_LOCKING_REQUEST_TYPE]: unlockRequest,
        });
    }
    createResponse(responseMessage) {
        return new LockResponse(responseMessage);
    }
    getDestination() {
        return this.destination;
    }
}
